import React from "react";
import { useField } from "../Form/useField";
import { Checkbox } from "../../components";

type Props = {
  label: string;
  className?: string;
  name: string;
  required?: boolean;
  defaultValue?: string;
};

const CheckboxField: React.FC<Props> = ({
  label,
  name,
  required,
  defaultValue = false
}) => {
  const { value, onChange } = useField({ name, required, defaultValue });

  return (
    <Checkbox
      checked={value}
      label={label}
      onChange={(_, checked) => onChange(checked)}
    />
  );
};

export default CheckboxField;
